/* eslint-env node */
const env = process.env.ENV
const publicCryptoKey = process.env.PUBLIC_CRYPTO_KEY
const sentryDsnPublic = process.env.SENTRY_DSN_PUBLIC
const mixpanelToken = process.env.MIXPANEL_TOKEN
const apiEndpoint = process.env.API_ENDPOINT

export { env, publicCryptoKey, sentryDsnPublic, mixpanelToken, apiEndpoint }
